module.exports = __webpack_public_path__ + "img/favonius-greatsword.f84f8d6e.webp";